// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

// Components
import {
  StyledLabel,
  StyledDescription,
  StyledInputWrap,
  StyledStepTitle,
  StyledSelectWrap,
  StyledButton,
  StyledButtonsWrap,
  StyledImportForm,
  StyledUploadContent,
  StyledContentWrapper,
  StyledUploadingBox,
} from '../Styled';
import { DocumentUploadDragger } from '@/components';
import { DocumentIcon, GhostRefreshingIcon, ReplaceIcon } from '@/icons';
import { Button, Checkbox } from '@/ui';

// Models
import { ROUTES } from '@/models/router.model';

type TPreparingStepContainer = {
  onFileUpload: (file: File | Blob) => void;
  onUploadStepSubmit: () => void;
  setWithPhotos: (v: boolean) => void;
  resetFile: () => void;
  selectedFile?: File;
  success?: boolean;
  canManage: boolean;
};

const PreparingStepContainer = ({
  onFileUpload,
  onUploadStepSubmit,
  selectedFile,
  setWithPhotos,
  success,
  resetFile,
  canManage,
}: TPreparingStepContainer) => {
  const { t } = useTranslation(['products']);
  const navigate = useNavigate();
  const goToImportsList = () => {
    navigate(ROUTES.IMPORTS_LIST);
  };

  return (
    <StyledContentWrapper>
      <StyledImportForm>
        <StyledStepTitle>{t('products_import_step', { step: 2 })}</StyledStepTitle>
        <StyledInputWrap>
          <StyledLabel>{t('products_import_file_uploading')}</StyledLabel>
          <StyledSelectWrap>
            <StyledDescription>{t('products_import_file_uploading_description')}</StyledDescription>
          </StyledSelectWrap>
        </StyledInputWrap>
        {selectedFile ? (
          <StyledUploadContent>
            <DocumentIcon />
            {selectedFile.name}
          </StyledUploadContent>
        ) : (
          <DocumentUploadDragger value={selectedFile} onChange={onFileUpload} acceptance={'.xlsx'} />
        )}
        <Checkbox onChange={(e: CheckboxChangeEvent) => setWithPhotos(e.target.checked)}>
          {t('products_import_refresh_photo')}
        </Checkbox>
        {selectedFile && (
          <StyledButtonsWrap>
            {canManage && (
              <StyledButton type={'primary'} onClick={onUploadStepSubmit}>
                {t('products_import_start_import')}
              </StyledButton>
            )}
            <StyledButton onClick={resetFile}>
              <ReplaceIcon />
              {t('products_import_reset_file')}
            </StyledButton>
          </StyledButtonsWrap>
        )}
      </StyledImportForm>
      {success && (
        <StyledUploadingBox>
          <GhostRefreshingIcon />
          <span>{t('products_import_importing_message')}</span>
          <Button onClick={goToImportsList}>{t('products_import_go_to_table')}</Button>
        </StyledUploadingBox>
      )}
    </StyledContentWrapper>
  );
};

export default PreparingStepContainer;
